import { render, staticRenderFns } from "./PropatySetting.vue?vue&type=template&id=2a15da06&scoped=true&"
import script from "./PropatySetting.vue?vue&type=script&lang=js&"
export * from "./PropatySetting.vue?vue&type=script&lang=js&"
import style0 from "./PropatySetting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PropatySetting.vue?vue&type=style&index=1&id=2a15da06&scoped=true&lang=css&"
import style2 from "./PropatySetting.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15da06",
  null
  
)

export default component.exports